import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RecoveryPasswordPageComponent } from '../../page/recovery-password/recovery-passwordPage.component';

@Component({
  selector: 'app-message-dialog',
  templateUrl: './message-dialog.component.html',
  styleUrls: ['./message-dialog.component.css']
})
export class MessageDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<RecoveryPasswordPageComponent>, @Inject(MAT_DIALOG_DATA) public obj: any) {
   }

  ngOnInit(): void {
  }

  closeDialog(){
    this.dialogRef.close();
  }

}
